
import axios from "axios";

import { BackendUrl } from "@/auth.config";

const BackendUrlInstall = `${BackendUrl}/install`;
const BackendUrlAlarm = `${BackendUrl}/alarm`;
const BackendUrlModel = `${BackendUrl}/brandmodel`;
const BackendUrlEvent = `${BackendUrl}/event`;
const BackendUrlInventory = `${BackendUrl}/inventory`;
const BackendUrlVisuData = `${BackendUrl}/visudata`;
const BackendUrlMask = `${BackendUrl}/mask`;
const BackendUrlAlarmQueries = `${BackendUrl}/alarmquery`;

// axios.defaults.baseURL = BackendUrl; // NOPE !! DON'T DO THAT

export default {
	get_blocs_install(install_id) {
		return axios.get(BackendUrlInstall+`/id/${install_id}/blocs`);
	},
	post_blocs_install(install_id, blocs) {
		return axios.post(BackendUrlInstall+`/id/${install_id}/blocs`, {blocs});
	},
	put_blocs_install(install_id, blocs) {
		return axios.put(BackendUrlInstall+`/id/${install_id}/blocs`, {blocs});
	},
	delete_blocs_install(install_id) {
		return axios.delete(BackendUrlInstall+`/id/${install_id}/blocs`);
	},
	get_m_pts_install(install_id) {
		return axios.get(BackendUrlInstall+`/id/${install_id}/m_pts`);
	},
	post_m_pts_install(install_id, m_pts) {
		return axios.post(BackendUrlInstall+`/id/${install_id}/m_pts`, {m_pts});
	},
	put_m_pts_install(install_id, m_pts) {
		return axios.put(BackendUrlInstall+`/id/${install_id}/m_pts`, {m_pts});
	},
	delete_m_pts_install(install_id) {
		return axios.delete(BackendUrlInstall+`/id/${install_id}/m_pts`);
	},
	get_edges_install(install_id) {
		return axios.get(BackendUrlInstall+`/id/${install_id}/edges`);
	},
	post_edges_install(install_id, edges) {
		return axios.post(BackendUrlInstall+`/id/${install_id}/edges`, {edges});
	},
	put_edges_install(install_id, edges) {
		return axios.put(BackendUrlInstall+`/id/${install_id}/edges`, {edges});
	},
	delete_edges_install(install_id) {
		return axios.delete(BackendUrlInstall+`/id/${install_id}/edges`);
	},
	launch_analysis(install_id,params){
		return axios.post(BackendUrlInstall+`/id/${install_id}/analysis`,{"config": JSON.stringify(params)})
	},


	get_alarm_id(alarm_id) {
		return axios.get(BackendUrlAlarm+`/id/${alarm_id}`);
	},
	post_alarm_id(alarm_id, install_id, json_data) {
		return axios.post(BackendUrlAlarm+`/id/${alarm_id}`, {install_id, json_data: JSON.stringify(json_data)});
	},
	put_alarm_id(alarm_id, install_id, json_data) {
		return axios.put(BackendUrlAlarm+`/id/${alarm_id}`, {install_id, json_data: JSON.stringify(json_data)});
	},
	delete_alarm_id(alarm_id) {
		return axios.delete(BackendUrlAlarm+`/id/${alarm_id}`);
	},
	get_alarm_install(install_id) {
		return axios.get(BackendUrlAlarm+`/install/${install_id}`);
	},
	get_alarms() {
		return axios.get(BackendUrlAlarm+`/all`);
	},
	put_file_for_alarm(alarm_id, file) {
		const formData = new FormData()
		formData.append("file", file)
		return axios.put(BackendUrlAlarm+`/id/${alarm_id}/file`, formData)
	},

	get_file_for_alarm(alarm_id){
		return axios.get(BackendUrlAlarm+`/id/${alarm_id}/file`, { responseType: 'blob' })
	},



	get_models_inverters(install_id) {
		return axios.get(BackendUrlModel+`/install/${install_id}/inverter/all`)
	},
	post_model_inverter(install_id, json_data) {
		return axios.post(BackendUrlModel+`/install/${install_id}/inverter/new`, {json_data: JSON.stringify(json_data)})
	},
	get_models_modules(install_id) {
		return axios.get(BackendUrlModel+`/install/${install_id}/module/all`)
	},
	post_model_module(install_id, json_data) {
		return axios.post(BackendUrlModel+`/install/${install_id}/module/new`, {json_data: JSON.stringify(json_data)})
	},



	get_event_id(id, install_id) {
		return axios.get(BackendUrlEvent+`/install/${install_id}/event/${id}`)
	},
	post_event_install(install_id, json_data) {
		return axios.post(BackendUrlEvent+`/install/${install_id}/new`, {json_data: JSON.stringify(json_data)})
	},
	put_event_id(id, install_id, json_data) {
		return axios.put(BackendUrlEvent+`/install/${install_id}/event/${id}`, {json_data: JSON.stringify(json_data)})
	},
	delete_event_id(id, install_id) {
		return axios.delete(BackendUrlEvent+`/install/${install_id}/event/${id}`)
	},
	get_events_install(install_id) {
		return axios.get(BackendUrlEvent+`/install/${install_id}/all`)
	},



	get_install_form(install_id) {
		return axios.get(BackendUrlInventory+`/install/${install_id}`)
	},
	put_install_form(install_id, data) {
		return axios.put(BackendUrlInventory+`/install/${install_id}`, {description: JSON.stringify(data[0]), rampants_inventory: JSON.stringify(data[1]), inverters_inventory: JSON.stringify(data[2]), modules_inventory: JSON.stringify(data[3]), history: JSON.stringify(data[4]), layouts: JSON.stringify(data[5])})
	},
	delete_install_form(install_id) {
		return axios.delete(BackendUrlInventory+`/install/${install_id}`)
	},
	claim_new_install_id() {
		return axios.post(BackendUrlInventory+`/new`)
	},
	get_install_form_frag(install_id, frag_id) {
		return axios.get(BackendUrlInventory+`/install/${install_id}/frag/${frag_id}`)
	},
	put_install_form_frag(install_id, frag_id, data) {
		return axios.put(BackendUrlInventory+`/install/${install_id}/frag/${frag_id}`, {json_data: JSON.stringify(data[frag_id])})
	},
	get_installs() {
		return axios.get(BackendUrlInventory+`/all`)
	},
	get_draft_from_id(user_id, draft_id) {
		return axios.get(BackendUrlInventory+`/draft/${user_id}/id/${draft_id}`)
	},
	post_new_draft(user_id, name, install_id, json_data) {
		return axios.post(BackendUrlInventory+`/draft/${user_id}/new`, {name, install_id, json_data: JSON.stringify(json_data)})
	},
	put_draft_to_id(user_id, draft_id, name, install_id, json_data) {
		return axios.put(BackendUrlInventory+`/draft/${user_id}/id/${draft_id}`, {name, install_id, json_data: JSON.stringify(json_data)})
	},
	delete_draft_from_id(user_id, draft_id) {
		return axios.delete(BackendUrlInventory+`/draft/${user_id}/id/${draft_id}`)
	},
	get_all_drafts(user_id) {
		return axios.get(BackendUrlInventory+`/draft/${user_id}/all`)
	},
	get_production_data_from_id(id, install_id) {
		return axios.get(BackendUrlInventory+`/install/${install_id}/file/${id}`)
	},
	post_new_production_data(install_id, file, type) {
		const formData = new FormData()
		formData.append("file", file)
		return axios.post(BackendUrlInventory+`/install/${install_id}/newfile/type/${type}`, formData)
	},
	put_production_data_to_id(id, install_id, file, type) {
		const formData = new FormData()
		formData.append("file", file)
		return axios.put(BackendUrlInventory+`/install/${install_id}/file/${id}/type/${type}`, formData)
	},
	delete_production_data_from_id(id, install_id) {
		return axios.delete(BackendUrlInventory+`/install/${install_id}/file/${id}`)
	},
	get_all_production_data_metadatas(install_id) {
		return axios.get(BackendUrlInventory+`/install/${install_id}/allfiles`)
	},



	get_visudatas(install_id) {
		return axios.get(BackendUrlVisuData+"/install/" + install_id);
	},
	post_visudatas(install_id, name, levels, values) {
		return axios.post(BackendUrlVisuData+"/install/" + install_id, { name, levels: JSON.stringify(levels), values: JSON.stringify(values) });
	},
	delete_visudatas(install_id) {
		return axios.delete(BackendUrlVisuData+"/install/" + install_id);
	},



	get_mask_install(install_id) {
		return axios.get(BackendUrlMask+`/install/${install_id}`)
	},
	post_mask_install(install_id, coords) {
		return axios.post(BackendUrlMask+`/install/${install_id}`, {coords})
	},
	put_mask_install(install_id, coords) {
		return axios.put(BackendUrlMask+`/install/${install_id}`, {coords})
	},
	delete_mask_install(install_id) {
		return axios.delete(BackendUrlMask+`/install/${install_id}`)
	},
	get_mask_file_install(install_id) {
		return axios.get(BackendUrlMask+`/install/${install_id}/file`, { responseType: 'blob' })
	},
	post_mask_file_install(install_id, file) {
		const formData = new FormData()
		formData.append("file", file)
		return axios.post(BackendUrlMask+`/install/${install_id}/file`, formData)
	},
	put_mask_file_install(install_id, file) {
		const formData = new FormData()
		formData.append("file", file)
		return axios.put(BackendUrlMask+`/install/${install_id}/file`, formData)
	},
	delete_mask_file_install(install_id) {
		return axios.delete(BackendUrlMask+`/install/${install_id}/file`)
	},



	get_alarmquery_id(alarm_id) {
		return axios.get(BackendUrlAlarmQueries+`/id/${alarm_id}`);
	},
	post_new_alarmquery(alarm_name, bloc_id, datapoint, geopoint, installation_id, user_id) {
		return axios.post(BackendUrlAlarmQueries+`/new`, {alarm_name, bloc_id, datapoint, geopoint, installation_id, user_id});
	},
	put_alarmquery_id(alarm_id, alarm_name, bloc_id, datapoint, geopoint, installation_id, user_id) {
		return axios.put(BackendUrlAlarmQueries+`/id/${alarm_id}`, {alarm_name, bloc_id, datapoint, geopoint, installation_id, user_id});
	},
	delete_alarmquery_id(alarm_id) {
		return axios.delete(BackendUrlAlarmQueries+`/id/${alarm_id}`);
	},
	get_alarmquery_install(install_id) {
		return axios.get(BackendUrlAlarmQueries+`/install/${install_id}`);
	},
	get_alarmqueries() {
		return axios.get(BackendUrlAlarmQueries+`/all`);
	}
}

// EOF
